import { mountSlider } from "../src/components/product-slider";
import { $Q, $Qll } from "../src/utils/query-selector";

const swiperPrincipal = mountSlider($Q('.swiper.main-product__slider-principal'));

/**
 * This function is responsible for filtering the 
 * slider slider according to the id of the variant
 * @param {Number} variantId 
 * @returns {Html} Node Html
 */
const filterSlide = (variantId, parent) => {
  const lstSlides = $Qll('.slide-js', parent);
  if(lstSlides.length === 0) return; 
  const node = [...lstSlides].find(slide => {
    return slide.dataset.alt === variantId;
  });

  return {
    node,
    lstSlides
  };
}

/**
 * The function hides all slides in a given list.
 * @param lstSlides - lstSlides is a parameter that represents an array of HTML elements that are
 * slides in a slideshow. The function loops through each slide in the array and adds the CSS class
 * 'hidden' to it, effectively hiding all the slides.
 * @returns If the length of the `lstSlides` array is less than or equal to 0, the function returns
 * nothing (undefined). Otherwise, the function adds the 'hidden' class to each slide in the array.
 */
const hiddenAllSlides = (lstSlides) => {
  if (lstSlides.length <= 0) return;
  lstSlides.forEach(slide => {
    slide.classList.add('hidden');
  })
}

/**
 * This function is responsible for changing the index of the 
 * slider using the slideTo method of Swiper slider
 * @param {String} variantId 
 */
export const changeIndexSlider = (variantId, parent) => {
  const objectFilter = filterSlide(variantId, parent);
  if(!objectFilter.node) return;
  const index = Number([...objectFilter.lstSlides].indexOf(objectFilter.node, 0));
  swiperPrincipal[0]
    ? swiperPrincipal[0].slideTo(index, 500, false)
    : swiperPrincipal.slideTo(index, 500, false);
}
